import { styledOmitCustomProps } from '@braskai/ui-kit';

import { Box, BoxProps, styled, Theme } from '@mui/material';

type TContainerProps = {
  $isBusiness: boolean;
  $isCreatorPro: boolean;
  $isCurrentPlan: boolean;
  $isDisabled: boolean;
  $isEnterprise: boolean;
} & BoxProps;

const getBorder = (
  isEnterprise: boolean,
  isCreatorPro: boolean,
  isDisabled: boolean,
  isCurrentPlan: boolean,
  theme: Theme,
) => {
  const defaultStyle = `1px solid ${theme.palette.grey[200]}`;

  if (isCurrentPlan || isDisabled) return defaultStyle;

  if (isEnterprise) return 'none';

  // Creator Pro is the highlighted plan.
  if (isCreatorPro) return `2px solid ${theme.palette.primary[600]}`;

  return defaultStyle;
};

const getBackgroundColor = (isEnterprise: boolean, isCurrentPlan: boolean, theme: Theme) => {
  if (isCurrentPlan) return theme.palette.grey[50];

  // Enterprise uses the dark Rask/900 surface from the design.
  if (isEnterprise) return theme.palette.primary[900];

  return theme.palette.common.white;
};

export const SContainer = styled(
  Box,
  styledOmitCustomProps,
)<TContainerProps>(({ $isDisabled, $isEnterprise, $isCreatorPro, $isCurrentPlan, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: 24,
  minWidth: '100%',
  background: getBackgroundColor($isEnterprise, $isCurrentPlan, theme),
  color: $isEnterprise && !$isCurrentPlan ? theme.palette.common.white : 'inherit',
  border: getBorder($isEnterprise, $isCreatorPro, $isDisabled, $isCurrentPlan, theme),
  borderRadius: 16,
  padding: 24,
  position: 'relative',
  boxSizing: 'border-box',
}));
